import { Link } from "react-router-dom"
import { ShoppingCart } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { useAppSelector } from "@/store/hooks"

export default function CartButton(): React.JSX.Element {
	// Suma reactiva de las cantidades en el carrito (Redux → re-render sin recargar).
	const count = useAppSelector(state => state.cart.products.reduce((total, product) => total + product.amount, 0))

	return (
		<Button asChild variant="ghost" size="icon" className="relative" aria-label="Ver carrito">
			<Link to="/checkout">
				<ShoppingCart className="h-6 w-6" />
				{count > 0 && (
					<Badge
						className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full border-transparent bg-red-600 px-1 text-xs text-white hover:bg-red-600"
						aria-label={`${count} artículos en el carrito`}
					>
						{count > 9 ? "9+" : count}
					</Badge>
				)}
			</Link>
		</Button>
	)
}
